import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const UserTaskPercentReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default UserTaskPercentReport
